import {list} from "@mc/mc-legacy";
import QsignPracovnikApi from "../api/gen/qsign/QSignPracovnikApi";
import SignRequestInternalApi from "../api/gen/qsign/SignRequestInternalApi";

export const QSIGN_REQEST_PERSON_LIST = "qsignRequestPersonList";
export const QSIGN_PERSON_LIST = "qsignPersonList";
export const CONFIGURATIONS_LIST = "configurationsList";
export const APPROVAL_CONFIGURATIONS_LIST = "approvalConfigurationsList";

export function fetchQsingReqestPersonList(force = false) {
    return (dispatch, getState) => {
        dispatch(
            list.SimpleListActions.fetchIfNeeded(
                QSIGN_REQEST_PERSON_LIST,
                null,
                (parent, filter) => {
                    return QsignPracovnikApi.findAllReqestPersonList();
                },
                force
            )
        );
    };
}

export function findAllPersons(force = false) {
    return (dispatch, getState) => {
        dispatch(
            list.SimpleListActions.fetchIfNeeded(
                QSIGN_PERSON_LIST,
                null,
                (parent, filter) => {
                    return QsignPracovnikApi.findAllPersons();
                },
                force
            )
        );
    };
}

export function fetchSignConfigurationsList(force = false) {
    return (dispatch, getState) => {
        dispatch(
            list.SimpleListActions.fetchIfNeeded(
                CONFIGURATIONS_LIST,
                null,
                (parent, filter) => {
                    return QsignPracovnikApi.findConfigurations();
                },
                force
            )
        );
    };
}

export function fetchApprovalConfigurationsList(force = false) {
    return (dispatch, getState) => {
        dispatch(
            list.SimpleListActions.fetchIfNeeded(
                APPROVAL_CONFIGURATIONS_LIST,
                null,
                (parent, filter) => {
                    return QsignPracovnikApi.findApprovalConfigs();
                },
                force
            )
        );
    };
}
